import { useEffect, useState } from 'react';

/**
 * Custom hook to determine the maximum number of items to display based on screen size
 * Returns the count of items that should be shown (excluding the "See More" button)
 */
export const useResponsiveItemCount = () => {
  const [itemCount, setItemCount] = useState(7); // mobile default

  useEffect(() => {
    const updateItemCount = () => {
      const width = window.innerWidth;
      if (width >= 1536) {
        // 2xl: 2 rows × 6 columns - 1 for see more = 11 items
        setItemCount(11);
      } else if (width >= 768) {
        // md: 2 rows × 5 columns - 1 for see more = 9 items
        setItemCount(9);
      } else {
        // mobile: 2 rows × 4 columns - 1 for see more = 7 items
        setItemCount(7);
      }
    };

    updateItemCount();
    window.addEventListener('resize', updateItemCount);
    return () => window.removeEventListener('resize', updateItemCount);
  }, []);

  return itemCount;
};
